import AdminLab from "./AdminLab.vue";

export default AdminLab;
